import { getStatementLines } from "@bToC/Store/Data/StatementLines/StatementLinesSelector";
import updateLineSearchFields from "@bToC/Store/Pages/StatementDetails/Handlers/UpdateLineSearchFields";
import { CustomState } from "@bToC/Store/Reducers";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomState) => ({
    statementLinesData: getStatementLines(state),
});

const mapDispatchToProps = {
    updateLineSearchFields,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface StatementDetailsPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const paginationDetailsStyles: StatementDetailsPaginationStyles = {};

const styles = paginationDetailsStyles;

const StatementDetailsPagination: FC<Props> = ({ updateLineSearchFields, statementLinesData }) => {
    const changePage = (newPageIndex: number) => {
        updateLineSearchFields({
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateLineSearchFields({
            page: 1,
            pageSize: newPageSize,
        });
    };

    if (!statementLinesData.value) {
        return null;
    }

    const pagination = statementLinesData.value.pagination;
    if (!pagination || pagination.totalItemCount === 0) {
        return null;
    }

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={pagination.totalItemCount}
            currentPage={pagination.page}
            resultsPerPage={pagination.pageSize}
            resultsPerPageOptions={pagination.pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            pageSizeCookie="Statements-Details-PageSize"
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(StatementDetailsPagination),
    definition: {
        group: "Basic",
        displayName: "Statements Details Pagination",
    },
};

export default widgetModule;
